import React, { FC } from "react"
import { ReactComponent as IconClose } from "icons/lib/close-icon.svg"
import { ReactComponent as IconTrash } from "icons/lib/trash.svg"

interface RemoveButtonProps {
    className?: string
    icon: "trash" | "close"
    testId?: string
    onRemove: () => void
}

export const RemoveButton: FC<RemoveButtonProps> = ({
    className,
    icon,
    testId,
    onRemove
}) => (
    <button
        type="button"
        data-testid={testId}
        onClick={onRemove}
        className={`${className ?? ""} w-8 flex items-center p-2`}
    >
        {icon === "trash" ? <IconTrash /> : <IconClose />}
    </button>
)
